<script>
import axios from 'axios';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';

export default {
  name: 'Quiz',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  props: {
    training: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      answerSelections: [],
      isTryAgainPageDisplayed: false,
    };
  },
  methods: {
    toggleSelection(answerId) {
      if (this.answerSelections) {
        const index = this.answerSelections.indexOf(answerId);

        if (index > -1) {
          this.answerSelections.splice(index, 1);
        } else {
          this.answerSelections.push(answerId);
        }
      } else {
        this.answerSelections = [answerId];
      }
    },
    submit() {
      axios.post('/training/validate', { trainingId: this.training.id, answerSelections: this.answerSelections })
        .then((res) => {
          if (res.data.isCorrect) {
            console.log('SUCCESS!');
            this.$emit('success');
          } else {
            this.isTryAgainPageDisplayed = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reset() {
      this.answerSelections = [];
      this.isTryAgainPageDisplayed = false;
      this.$emit('reset');
    },
  },
};
</script>

<template>
  <div>

    <div v-if="isTryAgainPageDisplayed">
      <v-layout row wrap>
        <v-flex xs12 md12>&nbsp;</v-flex>
        <v-flex xs12 md12 >
          <div style="color: #D32F2F;">
            <!-- eslint-disable -->
            <span v-if="training.videoUrl">
              Sie haben leider nicht alle Fragen korrekt beantwortet. Bitte sehen Sie sich das Schulungsvideo noch einmal aufmerksam an und versuchen Sie es erneut.
              Sie können sich auch ausloggen und es später noch einmal versuchen.
            </span>
            <span v-else>
              Sie haben leider nicht alle Fragen korrekt beantwortet. Sie können jetzt oder auch später einen neuen Versuch starten.
            </span>
            <!-- eslint-enable -->
          </div>
        </v-flex>
        <v-flex xs12 md12>&nbsp;</v-flex>
      </v-layout>
      <v-layout row wrap>
        <div v-if="training.videoUrl">
          <v-btn @click.native="reset"
                 color="blue"
                 flat>
            Zurück zum Video
          </v-btn>
        </div>
        <div v-else>
          <v-btn @click.native="reset"
                 color="blue"
                 flat>
            Neuer Versuch
          </v-btn>
        </div>
      </v-layout>
    </div>
    <div v-else>
      <v-form>
        <v-container fluid grid-list-lg pt-2 pa-0>
          <div v-for="(question, index) in training.questions" :key="index" >
            <v-layout row wrap>
              <v-flex xs12 md12>
                <div>{{ (index + 1) + ') ' + question.text }}</div>
                <div v-for="(answer, index) in question.answers" :key="index" >
                  <v-flex md12 py-0>
                    <v-checkbox
                      @click.native="toggleSelection(answer.id)"
                      :label="answer.text"
                      class="caption"
                      hide-details
                    />
                  </v-flex>
                </div>
                <v-flex xs12 md12/>
              </v-flex>
            </v-layout>
          </div>
          <v-layout row wrap>
            <v-btn @click.native="submit"
                   color="blue"
                   flat>
              Antworten abschicken
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
